import { ElementRef } from '@angular/core';

export function syncMultiselectDropdowns(elementRef: ElementRef): void {
  const dropdowns = elementRef.nativeElement.querySelectorAll(
    'sh-multiselect-dropdown',
  );

  dropdowns.forEach((dropdown: any) => {
    const menuItems = dropdown.querySelectorAll('sh-menu-item');
    if (!menuItems.length) return;

    const rawValue = dropdown.value;
    if (!rawValue) return;

    const selectedValues: string[] = Array.isArray(rawValue)
      ? rawValue
          .map((v: string) => String(v).trim())
          .filter((v: string) => v)
      : String(rawValue)
          .split(',')
          .map((v: string) => v.trim())
          .filter((v: string) => v);

    if (!selectedValues.length) return;

    const multiValue: string[] = [];
    menuItems.forEach((menuItem: any) => {
      const itemData = menuItem.value || menuItem.label || '';
      if (selectedValues.includes(itemData)) {
        menuItem.active = true;
        multiValue.push(itemData);
      } else {
        menuItem.active = false;
      }
    });

    dropdown.multiValue = multiValue;
    dropdown.value = multiValue.join(',');
  });
}

export function scrollToConditionRow(
  groupIndex: number,
  conditionIndex: number,
  elementRef: ElementRef,
  expandManualQuery: boolean,
): void {
  setTimeout(() => {
    const container: HTMLElement | null =
      (expandManualQuery
        ? elementRef.nativeElement.querySelector('.manual-query-expand-modal')
        : elementRef.nativeElement.querySelector('.template-content-host')) ||
      elementRef.nativeElement;

    const row = container?.querySelector(
      `#cond-row-${groupIndex}-${conditionIndex}`,
    ) as HTMLElement | null;

    if (row) {
      row.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
}
